import zonesApi from '../api/zonesApi';
import {actions as notificationActions} from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  IMPORT_ZONES_FROM_OTHER_TENANT: 'IMPORT_ZONES_FROM_OTHER_TENANT',
  IMPORT_ZONES_FROM_OTHER_TENANT_SUCCESS: 'IMPORT_ZONES_FROM_OTHER_TENANT_SUCCESS',
  IMPORT_ZONES_FROM_OTHER_TENANT_FAILURE: 'IMPORT_ZONES_FROM_OTHER_TENANT_FAILURE',

};

export const actions = {

  importZonesFromOtherTenant: data => dispatch => {
    dispatch({type: types.IMPORT_ZONES_FROM_OTHER_TENANT});
    return zonesApi.ImportZonesFromOtherTenant(data).then(res => {
      if (res.ok) {
        if (res.data.success === false) {
          dispatch({type: types.IMPORT_ZONES_FROM_OTHER_TENANT_FAILURE});
          dispatch(notificationActions.showError(res.data.failure.message));
          return false;
        }
        dispatch({type: types.IMPORT_ZONES_FROM_OTHER_TENANT_SUCCESS});
        dispatch(notificationActions.showSuccess('Zaimportowano strefy'));
        return true;
      } else {
        dispatch({type: types.IMPORT_ZONES_FROM_OTHER_TENANT_FAILURE});
        dispatch(notificationActions.showError('Wystąpił problem podczas importowania stref'));
        return logger.error(res.data);
      }
    });
  },
};
